/**
 * Created by idea on 03/07/2017.
 */
import {Component, OnInit, ViewEncapsulation} from '@angular/core';

declare var jQuery:any;
declare var $:any;
declare var Site:any;

@Component({
    selector: 'admin',
    templateUrl: 'admin.template.html',
    styleUrls: ['style.css'],
    encapsulation: ViewEncapsulation.None,
})

export class adminComponent implements OnInit{
    public typeNav :string = '';
    public menuHide = false;

    constructor(){
        let body = document.getElementsByTagName('body')[0];
        // body.classList.remove("animsition");
        body.classList.remove("page-login-v2");
        body.classList.remove("page-register-v2");
        body.classList.remove("layout-full");
        body.classList.remove("page-dark");
        body.classList.add("site-menubar-unfold");

        // if (localStorage.getItem('User')) {
        //     let user = JSON.parse(localStorage.getItem('User'));
        //     let isShop = localStorage.getItem('isShop');
        //     if(isShop == 'false'){
        //         this.typeNav = 'ctv';
        //     }else{
        //         this.typeNav = 'shop';
        //     }
        // }
    }
    ngOnInit(){
        $(document).ready(function($) {
            // Site.run();
        });

    }

    handleNavUpdated(type){
        this.typeNav = type;
    }

    toggleMenu(){
        if(!this.menuHide){
            $('.menu-block').addClass('menu_hide');
            $('#evs_page').addClass('has_menu');
            $('.menu-block i.fa-bars').addClass('has_menu');
            this.menuHide = true;
        }else {
            $('.menu-block').removeClass('menu_hide');
            $('#evs_page').removeClass('has_menu');
            $('.menu-block i.fa-bars').removeClass('has_menu');
            this.menuHide = false;
        }
    }
}



// WEBPACK FOOTER //
// /app/src/app/layout/layouts/admin.component.ts